import React from "react";
import ReactDOM from "react-dom";

import { AppStandalone } from "./AppStandalone";

ReactDOM.render(
  <React.StrictMode>
    <AppStandalone />
  </React.StrictMode>,
  document.getElementById("root")
);
